import { useForm } from 'components/form/Form';
import { useGroup } from 'components/form/hook/useGroup';
import { classNames } from 'libs/react';
import { useEffect } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Radio } from 'components/form/private/controls/Radio';
import { Icon } from 'components/Icon';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { React } from 'libs/react';
import './FormRadio.scss';
/**
 * @component FormRadio
 * @since 1.0.0
 */
export function FormRadio(props) {
    let { name, style, label, infos, picto, value, error, required, optional, disabled, silenced, tooltip, prefix, suffix } = Object.assign({ style: 'normal', value: '' }, props);
    const form = useForm();
    const node = useRef(null);
    const [ident] = useIdent('form-radio');
    const [setValue] = useGroup(name, value, '');
    const [focused, setFocused] = useState(false);
    const [checked, setChecked] = useState(props.checked || false);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(checked) {
        setChecked(checked);
        /*
         * The radio input is a disguised select. When a radio is selected
         * we assign its value in the form slot reserved for its name.
         */
        if (checked) {
            setValue(value);
        }
    }
    useIf(focused, props.onFocus, props.onBlur);
    useWatch(() => {
        if (props.onChange) {
            props.onChange(checked);
        }
    }, [checked]);
    useEffect(() => {
        /*
         * The radio input is a disguised select. When a radio is selected
         * we assign its value in the form slot reserved for its name.
         */
        if (checked) {
            setValue(value);
        }
    }, [checked]);
    useEffect(() => {
        props.checked != null && setChecked(props.checked);
    }, [props.checked]);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-radio', 'form-radio--' + style, { 'form-radio--is-required': required }, { 'form-radio--is-disabled': optional }, { 'form-radio--is-disabled': disabled }, { 'form-radio--is-silenced': silenced }, { 'form-radio--is-checked': checked }, { 'form-radio--is-focused': focused }, { 'form-radio--has-label': label }, { 'form-radio--has-picto': picto }, { 'form-radio--has-error': error }, props.className);
    if (silenced) {
        error = null;
    }
    return (React.createElement("div", { ref: node, className: className },
        React.createElement("div", { className: "form-radio-field" },
            React.createElement("div", { className: "form-radio-field-head" },
                label && (React.createElement(FormFieldLabel, { className: "form-radio-label", style: style, label: label, ident: ident, tooltip: tooltip, required: required, optional: optional, disabled: disabled })),
                infos && (React.createElement(FormFieldInfos, { className: "form-radio-infos", style: style, infos: infos }))),
            React.createElement("div", { className: "form-radio-field-body" },
                prefix && React.createElement("div", { className: "form-radio-prefix" }, prefix),
                React.createElement(Radio, { name: name, outer: node, ident: ident, value: value, checked: checked, required: required, disabled: disabled, onBlur: onBlur, onFocus: onFocus, onChange: onChange }),
                React.createElement(When, null,
                    React.createElement(Case, { is: picto },
                        React.createElement(Icon, { className: "form-radio-picto", value: picto })),
                    React.createElement(Else, null,
                        React.createElement("div", { className: "form-radio-indicator" }),
                        React.createElement("div", { className: "form-radio-indicator" }))),
                suffix && React.createElement("div", { className: "form-text-area-suffix" }, suffix))),
        React.createElement(FormFieldError, { error: error })));
}
